import * as tConst from "../../common/Constants";
import { pickColorAdo } from "../../utils/pickColor";

const emptyString= "";


export function PrepareTimelineDataAdo (items, viewId, assigneeFilterName = tConst.ADO_ASSIGNED_ALL, assigneeFilterTeam = tConst.VIEW_ALL_TEAMS) {
    
    let dataset = [];
    let _minDate = new Date(2999, 11, 31);
    let _maxDate = new Date(1970, 0, 1);

    if (items != null && items.length > 0) {
        const tempItems2 = items.filter((item) => {
            const end =  new Date(item.fields[tConst.AF_END_ITERATION])
            const status = item.fields[tConst.AF_STATE]
            const now = new Date() 
            const from = new Date(item.fields[tConst.AF_START_ITERATION])
            if ((viewId ? viewId : tConst.VIEW_ALL_PLANNED) === tConst.VIEW_ALL_PLANNED){
                return true;
            } else if (viewId === tConst.VIEW_ACTIVE_AND_CURRENT){
                return (end >= now || tConst.ADO_INACTIVE_STATUSES.indexOf(status) ===-1 )
            } else if (viewId === tConst.VIEW_ACTIVE){
                const a = status in tConst.ADO_INACTIVE_STATUSES;
                return (tConst.ADO_INACTIVE_STATUSES.indexOf(status) === -1)
            } else if (viewId === tConst.VIEW_CURRENT_ITERATION){
                return (end >= now && from <= now) 
            } else if (viewId === tConst.VIEW_FUTURE){
                return end >= now;
            }
        
        })

        dataset = tempItems2?.sort((a, b) => a.planningPri > b.planningPri ? 1 : -1).map((item) => {            
            let fromDate = new Date(item.fields[tConst.AF_START_ITERATION])
            let endDate =  new Date(item.fields[tConst.AF_END_ITERATION])
            if  (endDate< fromDate) {
                const tempDate = fromDate;
                fromDate = endDate;
                endDate = tempDate;
            }
            if (_minDate > fromDate) {
                _minDate = fromDate;
            };
            if (_maxDate < endDate) {
                _maxDate = endDate;
            };

            const tooltip =         "<div style='white-space: nowrap; margin: 1em;'>"
            + "["+item.id+"] "+item.fields[tConst.AF_TITLE]
            + "<br/>Assignee: " + item.Assignee
            + "<br/>Status: " + item.fields[tConst.AF_STATE] + (item.fields[tConst.AF_PLANNING_STATUS]? "&nbsp / &nbsp"+ item.fields[tConst.AF_PLANNING_STATUS] : "")
            + "<br/>Priority: " + (item.fields[tConst.AF_PLANNING_PRIORITY] ? item.fields[tConst.AF_PLANNING_PRIORITY] : "<Unprioritized>") // + " / " + ticket.guestimate + " guestimate"
            + "<br/>Period: " + tConst.formatDate(fromDate) + " - " + tConst.formatDate(endDate)
            + "<br/>Epic/ Initiativ: "+emptyString + "<epic>"+emptyString + " / " + item.fields[tConst.AF_INITIATIV]
            + "<br/>Type: " + item.fields[tConst.AF_WORKITEM_TYPE]
            + "<br/>Teams: " + item.Teams.join(", ")
            + "</div>";

            const _type = item.fields[tConst.AF_WORKITEM_TYPE]
            const prefix = _type === "Epic" ? "E " : _type === "Initiative" ? "I " : _type ===  "Feature" ? "F ": _type === "Product Backlog Item" ? "P " : "";
            
            let _dimColor = false;
            if (assigneeFilterName !== tConst.ADO_ASSIGNED_ALL){
                 _dimColor = (assigneeFilterName !== item.Assignee)
            }
            if (assigneeFilterTeam === tConst.VIEW_NO_TEAMS) {
                _dimColor = (item.Teams.length !== 0)
            }
            else if (assigneeFilterTeam !== tConst.VIEW_ALL_TEAMS){
                _dimColor = (item.Teams.indexOf(assigneeFilterTeam) === -1)
            }
            return [
                (item.fields[tConst.AF_INITIATIV] && item.fields[tConst.AF_INITIATIV] !== "") ? item.fields[tConst.AF_INITIATIV] : "..",
                prefix+"["+item.id+"] " + item.fields[tConst.AF_TITLE],
                tooltip,
                pickColorAdo(item.fields[tConst.AF_STATE], item.fields[tConst.AF_PLANNING_STATUS],"", _dimColor ),
                fromDate,
                endDate
            ]
        } )  
    } 


    return {dataset, minDate: _minDate, maxDate: _maxDate}

}

